import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `De acuerdo con la metodología 2024, 1.100.000 niñas y niños viven en hogares en situación de pobreza por ingresos, cifra que equivale al 25% de la 
          población infantil del país.

  Para analizar la evolución de la pobreza en Chile, el Observatorio Social realizó estimaciones para el periodo 2009-2022 aplicando esta nueva metodología. Los 
          resultados evidencian una tendencia a la baja en los tramos de 0 a 3 y de 4 a 17 años, interrumpida únicamente en 2020. Producto de la pandemia y de la 
          crisis económica posterior, la incidencia repuntó al 37% en el grupo de menor edad y al 36% en el de 4 a 17 años[9].`,
    link: "https://public.flourish.studio/visualisation/20936193/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `No hay diferencias en la proporción de niñas y niños en hogares con pobreza multidimensional según el sexo, tanto en la metodología del 2013 como la del 2024.`,
    link: "https://public.flourish.studio/visualisation/27210112/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `La primera infancia constituye una etapa crucial para el desarrollo de habilidades cognitivas y socioemocionales, las cuales sientan las bases para el futuro 
          desempeño escolar, la inserción laboral y la autorrealización personal. Durante este período, la falta de acceso a recursos materiales básicos compromete el 
          desarrollo integral, generando impactos negativos que perduran a lo largo del ciclo vital[10].

  Dado que los efectos de la pobreza varían según la etapa de desarrollo en que se experimenten, resulta fundamental considerar esta especificidad y avanzar hacia una 
          medición de la pobreza infantil que incorpore dichas dimensiones. Sin embargo, bajo la actual estimación de pobreza por ingresos a nivel de hogar, no se observan 
          diferencias estadísticamente significativas en la incidencia entre niñas y niños en ninguno de los años analizados.`,
    link: "https://public.flourish.studio/visualisation/20936204/embed",
  },
  {
    id: "graph4",
    title: "Análisis por país de nacimiento",
    menuTitle: "\u2022 País de nacimiento",
    text: `En 2024, un 39% de las niñas y niños que nacieron en otro país vive en hogares bajo la línea de pobreza, frente a un 24% de las niñas y niños nacidos en el 
          país. Si se observa la metodología 2013, esta brecha es persistente en toda la línea de tiempo, aunque la diferencia es menor entre ambos grupos que con la 
          nueva metodología.

  Se ha documentado que las trayectorias de desarrollo de extranjeros son distintas, y que aquellos que provienen específicamente de América Latina y el Caribe se enfrentan 
          una probabilidad mayor de vivir en situación de pobreza, no tener acceso al sistema de salud y de educación, sufrir hacinamiento y sostenerse con menores niveles 
          de capital social, sobre todo en la zona norte del país[11].`,
    link: "https://public.flourish.studio/visualisation/20936208/embed",
  },
  {
    id: "graph5",
    title: "Análisis por pertenencia a pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `Históricamente, las niñas y los niños que se identifican con algún pueblo originario han vivido en mayor proporción en hogares pobres en comparación con quienes 
          no se identifican. En 2024, con la nueva metodología, esta brecha se profundiza en comparación con la metodología anterior. Mientras que un 31% de las niñas y niños 
          que se identifican con un pueblo originario vive en hogares bajo la línea de pobreza, un 24% de las niñas y niños que no se identifica lo hace.`,
    link: "https://public.flourish.studio/visualisation/20936216/embed",
  },
  {
    id: "graph6",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `En Chile, la pobreza infantil tiende a ser mayor entre niñas y niños que residen en zonas rurales que urbanas. Ocurre el mismo fenómeno que con la identificación con 
          un pueblo originario: con la nueva metodología la brecha es mayor entre ambos grupos.`,
    link: "https://public.flourish.studio/visualisation/20936219/embed",
  },
  {
    id: "graph7",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `En 2024, con la nueva metodología, la región que tiene una mayor proporción de niñas y niños viviendo en hogares con pobreza por ingreso corresponde a La Araucanía con 
          un 37% y luego la región del Maule con un 34% Por otro lado, la región que tiene una menor proporción es Magallanes con un 14%.`,
    link: "https://public.flourish.studio/visualisation/21906124/embed",
  },
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
